<div class="flex flex-col gap-y-6">
  <div class="flex items-start justify-between">
    <div class="">
      <app-page-headline
        [headline]="'pages.uploadDetail.headline' | translate"
        [isLoading]="isLoading"
        [count]="total"
      />
    </div>
    <div class="flex gap-2">
      <app-back-button />
      <app-button
        data-test-id="startClearing"
        type="primary"
        [disabled]="!(this.branch?.state === 'WORKFLOW_UPLOAD_PROCESSED')"
        (trigger)="onClearing()"
      >
        <svg-icon src="assets/icons/General/upload-01.svg" />
        {{ 'pages.uploadDetail.clearing.label' | translate }}
      </app-button>
    </div>
  </div>

  <app-branch-detail-base
    [filterAllLabel]="'pages.uploadDetail.filter.all' | translate"
    [id]="id"
    [offset]="offset"
    [branch]="branch"
    [tableColumns]="[
      {
        key: 'actions',
        label: 'pages.uploadDetail.table.actions.label' | translate,
        width: '56px',
        align: 'right',
        fixRight: true,
        cellTemplate: actionCellTemplate,
        sort: false,
      },
    ]"
    (changeHandler)="onBaseUpdate($event)"
  />
</div>

<ng-template
  #actionCellTemplate
  let-currentRow="currentRow"
  let-index="index"
  [typedTemplate]="typeToken"
>
  <app-button
    class="inline-block"
    data-test-id="testButton"
    type="primary"
    shape="circle"
    [title]="'pages.uploadDetail.table.actions.view.title' | translate"
    [routerLink]="['./conflict-detail', currentRow.referenceId]"
    [queryParams]="{
      offset: offset + index + 1,
    }"
  >
    <svg-icon src="assets/icons/General/eye.svg" />
  </app-button>
</ng-template>
